import styled from "styled-components";

export const Container = styled.div`
  height: 16rem;
  margin: 0 -0.5rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[300]};
  box-shadow: inset 0 0.1rem 0.2rem rgba(0, 0, 0, 0.1),
    inset 0 0 0.2rem rgba(0, 0, 0, 0.2);
`;

export const ContainerInner = styled.div`
  height: 100%;
  padding: 3.4rem 3rem;
  position: relative;
`;

export const Graph = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const Bars = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-left: 20rem;
  position: absolute;
  right: 0;
  bottom: -3.4rem;
`;

export const Bar = styled.div`
  width: 2.4rem;
  margin-left: 4.2rem;
  cursor: pointer;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  opacity: ${({ isGhost }) => (isGhost ? 0.5 : 0.8)};
  background-color: ${({ theme, statusColor, isHovering }) =>
    isHovering
      ? theme.getColorSpectrumFromColor(statusColor)[500]
      : theme.getColorSpectrumFromColor(statusColor)[300]};

  &:first-child {
    margin-left: 0;
  }
`;

export const Legends = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const Legend = styled.div`
  width: 100%;
  height: 0.2rem;
  background-color: ${({ theme, color }) =>
    color || theme.styleGuide.colors.gray[500]};
  border-radius: 0.2rem;
  opacity: ${({ isHidden }) => (isHidden ? 0 : 1)};
  position: relative;
`;

export const LegendValue = styled.div`
  transform: ${({ isBelow }) =>
    isBelow ? "translateY(100%)" : "translateY(-100%)"};
  text-align: right;
  position: absolute;
  left: 0;
  top: ${({ isBelow, isAverage }) =>
    isBelow ? "auto" : isAverage ? "-0.1rem" : 0};
  bottom: ${({ isBelow }) => (isBelow ? 0 : "auto")};

  ${({ theme, isAverage }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 1.7rem;
    top: ${isAverage && "-0.2rem"};
  `}
`;

export const Value = styled.span`
  font-size: ${({ isAverage }) => (isAverage ? "2rem" : "1.4rem")};
  font-weight: ${({ isAverage }) => (isAverage ? 600 : 400)};
  line-height: ${({ isAverage }) => (isAverage ? "2.6rem" : "2rem")};
  color: ${({ theme, color }) => color || theme.styleGuide.colors.gray[700]};

  ${({ theme, isAverage }) => theme.media.sm`
    font-size: 1.5rem;
    line-height: ${isAverage && "1.8rem"};
    transform: ${isAverage && "translateY(-0.2rem)"};
  `}
`;

export const Label = styled.span`
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[600]};
  text-transform: uppercase;

  ${({ theme }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 1.7rem;
  `}
`;
